// extracted by mini-css-extract-plugin
export default {"root":"Switch_root__f+hr6","switchBase":"Switch_switchBase__2d9ag","thumb":"Switch_thumb__GneFN","track":"Switch_track__dKgnw","checked":"Switch_checked__gyY8L"};